import { render, staticRenderFns } from "./ResponsibleSelect.vue?vue&type=template&id=0144fbe8&"
import script from "./ResponsibleSelect.vue?vue&type=script&lang=ts&"
export * from "./ResponsibleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports